export default {
  async getCrux(appId) {
    return this.request(`/third-party/${appId}/crux`);
  },

  // Read-only: the app's own published catalog (see app_graph.py's list_app_nodes).
  // Same auth door as everything else here — jwt_auth_required + _can_manage_app —
  // so this only ever resolves for a developer who actually manages the app.
  async getAppCatalogNodes(appId, params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/third-party/${appId}/nodes${query ? '?' + query : ''}`);
  },
};
